import {formatMoney} from "//snapwireless.com.au/cdn/shop/t/381/assets/theme.js?v=117339979326568220511764012575";

//GLOBAL
window.not_scrolled = true;
window.not_opened = true;
window.variant_found = false;
window.protectionFixed = true;

//FREE 
function freeGiftDataUpdate() {
  let gift_limit = Math.round(parseFloat(document.getElementById('pricing-data').getAttribute('data-gift-limit')) * (Shopify.currency.rate || 1));
  let cart_total = parseFloat(document.getElementById('pricing-data').getAttribute('data-current-total'));
  
  $('.gift-progress').attr('aria-valuemax', gift_limit);
  $('.gift-progress').attr('aria-valuenow', cart_total);

  if(cart_total < gift_limit) {
    $('#gift-offer-block').removeClass('gift-free-complete'); // hide 
    $('.remaining-message').removeClass('gift-hide'); // show
    $('.free-button').removeClass('gift-hide'); // show
    $('.add-button').addClass('gift-hide'); // hide
    $('.success-message').addClass('gift-hide'); // hide
    $('.success-product-info').addClass('gift-hide'); // hide    
    $('.swap-price').html(formatMoney(gift_limit - cart_total).replace(/\AUD/g, ""));
   $('.progress-label .remaining-price').html(`
      <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="vertical-align:middle; margin-right:4px;">
        <path d="M5.11662 12.4492V6.44922M7.11662 3.78255H3.44995C3.00792 3.78255 2.584 3.60696 2.27144 3.2944C1.95888 2.98184 1.78328 2.55791 1.78328 2.11589C1.78328 1.67386 1.95888 1.24993 2.27144 0.937374C2.584 0.624813 3.00792 0.449219 3.44995 0.449219C4.44995 0.449219 5.36662 1.28255 6.03328 2.11589M7.78328 12.4492V6.44922M1.78328 6.44922H11.1166V11.7826C11.1166 11.9594 11.0464 12.1289 10.9214 12.254C10.7963 12.379 10.6268 12.4492 10.45 12.4492H2.44995C2.27314 12.4492 2.10357 12.379 1.97855 12.254C1.85352 12.1289 1.78328 11.9594 1.78328 11.7826V6.44922ZM1.11662 3.78255H11.7833C11.9601 3.78255 12.1297 3.85279 12.2547 3.97781C12.3797 4.10284 12.45 4.27241 12.45 4.44922V6.44922H0.449951V4.44922C0.449951 4.27241 0.520189 4.10284 0.645213 3.97781C0.770238 3.85279 0.939807 3.78255 1.11662 3.78255ZM9.21995 0.449219C7.21995 0.449219 5.55328 3.78255 5.55328 3.78255H9.21995C9.66198 3.78255 10.0859 3.60696 10.3985 3.2944C10.711 2.98184 10.8866 2.55791 10.8866 2.11589C10.8866 1.67386 10.711 1.24993 10.3985 0.937374C10.0859 0.624813 9.66198 0.449219 9.21995 0.449219Z" stroke="#41A1E1" stroke-width="0.9" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      Spend <strong>${formatMoney(gift_limit - cart_total)}</strong>`);

    $('.progress-label .progress-text').html(' more and get a FREE Travel Pouch!');  
  } else {     
    $('.remaining-message').addClass('gift-hide'); // show
    $('.free-button').addClass('gift-hide'); // show   
    $('.add-button').removeClass('gift-hide'); // hide
    $('.success-message').removeClass('gift-hide'); // show4
    //$('.success-product-info').removeClass('gift-hide'); // show    
    $('.remaining-limit').text('0');
    $('#gift-offer-block').addClass('gift-free-complete'); //show
    $('.progress-label .remaining-price').html('');
    $('.progress-label .progress-text').html("Congratulations you've unlocked a Free Gift!");  
  }
}

//CHANGE QUANTITY
async function lineItemQuantityChange(lineKey, targetQuantity) {
  
  const lineItem = document.getElementById('gift-block');
  lineItem?.dispatchEvent(new CustomEvent("line-item:will-change", { bubbles: true, detail: { targetQuantity } }));
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: {
      id: lineKey,
      quantity: targetQuantity,
      sections: sectionsToBundle
    }
  }).then((data) => {
    const lineItemAfterChange = data["items"].filter((lineItem2) => lineItem2["key"] === lineKey);
    lineItem?.dispatchEvent(new CustomEvent("line-item:change", { 
      bubbles: true, 
      detail: { 
        quantity: lineItemAfterChange.length === 0 ? 0 : lineItemAfterChange[0]["quantity"], 
        cart: data 
      } 
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
      bubbles: true, 
      detail: { 
        //baseEvent: "line-item:change",
        cart: data 
      } 
    }));
  });
  
}

//ADD ITEM
async function addItem(variant, form) {

  const formElement = document.getElementById(form);
  let sectionsToBundle = ["variant-added"];
  document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", { bubbles: true, detail: { sections: sectionsToBundle } }));
  
  const formData = new FormData(formElement);
  formData.set("sections", sectionsToBundle.join(","));
  formData.set("sections_url", `${Shopify.routes.root}variants/${variant}`);

  
  
  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    body: formData,
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest"
    }
  }); 
  
  const responseJson = await response.json();
  if (response.ok) { 
    
    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();   
    cartContent["sections"] = responseJson["sections"];
    
    formElement.dispatchEvent(new CustomEvent("variant:add", { 
      bubbles: true, 
      detail: { 
        items: responseJson.hasOwnProperty("items") ? responseJson["items"] : [responseJson], 
        cart: cartContent 
      } 
    }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:change", { 
      bubbles: true, 
      detail: { 
        //baseEvent: "variant:add",
        cart: cartContent 
      } 
    }));  
  } else {   
    this.dispatchEvent(new CustomEvent("cart:error", { 
      bubbles: true, 
      detail: { 
        error: responseJson["description"] 
      } 
    }));   
  }
  
}

if (document.getElementById('gift-block')!= null) {
   let gift_limit = Math.round(parseFloat(document.getElementById('pricing-data').getAttribute('data-gift-limit')) * (Shopify.currency.rate || 1));
   let cart_total = parseFloat(document.getElementById('pricing-data').getAttribute('data-current-total'));
   if(cart_total < gift_limit) {
     //UPDATE
     lineItemQuantityChange(parseInt(document.getElementById('gift-block').getAttribute('data-gift-id')), 0);
   } 
} else if (document.getElementById('gift-offer-block') != null) {
  let gift_limit = Math.round(parseFloat(document.getElementById('pricing-data').getAttribute('data-gift-limit')) * (Shopify.currency.rate || 1));
  let cart_total = parseFloat(document.getElementById('pricing-data').getAttribute('data-current-total'));
  if(cart_total > gift_limit && window.gift_auto_add) {
    //auto add
    addItem(parseInt(document.getElementById('gift-offer-block').getAttribute('data-variant-id')), "complementary-gift-product--"+parseInt(document.getElementById('gift-offer-block').getAttribute('data-id'))+"");  
  } 
}

freeGiftDataUpdate();

if (document.getElementById('gift-block')!= null) {
  document.getElementById('gift-offer-block').style.display = 'none';
} else {
  if (document.getElementById('gift-offer-block')!= null){
      document.getElementById('gift-offer-block').style.display = 'block';
  }
}


document.addEventListener('cart:change', function(event) {
  
  let gift_limit = Math.round(parseFloat(document.getElementById('pricing-data').getAttribute('data-gift-limit')) * (Shopify.currency.rate || 1));
  let cart_total = event.detail.cart.total_price;
  freeGiftDataUpdate();
  
  if (document.getElementById('gift-offer-block')!= null) {
    
    const product_check = event.detail.cart.items; 
    const variant_check = parseInt(document.getElementById('gift-offer-block').getAttribute('data-id'));

    for (var i = 0; i < product_check.length; i++) {
      if (product_check[i].product_id == variant_check) {
         window.variant_found = true;
        let gift_product = product_check[i];
        
        if (gift_product.quantity>1) { 
          //UPDATE
          //lineItemQuantityChange(gift_product.key, 1); 
        }
        
        if (gift_product.key != null && cart_total < gift_limit){
          document.getElementById('gift-offer-block').style.display = 'block';
          //UPDATE
          lineItemQuantityChange(gift_product.key, 0);
          document.head.insertAdjacentHTML("beforeend", `<style>#gift-block{display:none;}</style>`);
          window.variant_found = false;
          break;
        } else {
          document.getElementById('gift-offer-block').style.display = 'none';
          document.head.insertAdjacentHTML("beforeend", `<style>#gift-block{display:flex;}</style>`);
          window.variant_found = true;
          break;
        }
      } else {   
         window.variant_found = false;
      }
    }

    if (cart_total > gift_limit && window.variant_found == false && window.gift_auto_add) {
      //document.getElementById('gift-offer-block').style.display = 'block';
      //auto add
      document.getElementById('gift-offer-block').style.display = 'none';
      addItem(parseInt(document.getElementById('gift-offer-block').getAttribute('data-variant-id')), "complementary-gift-product--"+parseInt(document.getElementById('gift-offer-block').getAttribute('data-id'))+"");
    } else if (cart_total > gift_limit && window.variant_found == false && window.gift_auto_add == false) { document.getElementById('gift-offer-block').style.display = 'block'; }
  }  
  
});

//CONVERSION: A, B, C, LABEL
if (Shopify.currency.active != 'AUD' ) {
  if (document.querySelector('.conversion-a') !=null ) {
    const conversion_a = parseFloat(document.querySelector('.conversion-a').textContent);
    document.querySelectorAll(".conversion-a").forEach(function(element) {
      element.textContent = formatMoney((conversion_a * (Shopify.currency.rate || 1) * 100),window.themeVariables.settings.moneyFormat.replace("amount", "amount_no_decimals"));
    });
  }
  if (document.querySelector('.conversion-b') !=null ) {
    const conversion_b = parseFloat(document.querySelector('.conversion-b').textContent);
    document.querySelectorAll(".conversion-b").forEach(function(element) {
      element.textContent = formatMoney((conversion_b * (Shopify.currency.rate || 1) * 100),window.themeVariables.settings.moneyFormat.replace("amount", "amount_no_decimals"));
    });
  }
  if (document.querySelector('.symbol-a') !=null ) {
      document.querySelectorAll(".symbol-a").forEach(function(element) {
        element.remove();
      });  
  }
  if (document.querySelector('.symbol-b') !=null ) {
      document.querySelectorAll(".symbol-b").forEach(function(element) {
        element.remove();
      });  
  }
  if (document.querySelector(".announcement-bar__scrolling-list") !=null){ document.querySelector(".announcement-bar__scrolling-list").style.visibility = "visible";}
  if (document.querySelector(".announcement-bar__wrapper") !=null){ document.querySelector(".announcement-bar__wrapper").style.visibility = "visible";}

  if (document.querySelector('.product-card__label') !=null ) {
    document.querySelectorAll(".product-card__label").forEach(function(element) {
      if (element.textContent.includes('$')){
        //element.style.visibility = "hidden";
        const save_text = element.textContent.split("$")[0];
        const save_amount = Math.round((element.textContent.split("$")[1]) * (Shopify.currency.rate || 1) * 100);
        element.innerHTML = save_text;
        element.append(formatMoney(save_amount,window.themeVariables.settings.moneyFormat.replace("amount", "amount_no_decimals")));
        element.style.visibility = "visible";
      }
    });  
  }
  
}
if (Shopify.currency.active != 'AUD' ) {
  if (document.getElementById('conversion-c') !=null) { 
    document.getElementById('conversion-c').innerHTML = formatMoney((0 * (Shopify.currency.rate || 1) * 100),window.themeVariables.settings.moneyFormat.replace("amount", "amount_no_decimals")); 
  }
} else {
  if (document.getElementById('conversion-c') !=null) { 
    document.getElementById('conversion-c').innerHTML = formatMoney(0 * (Shopify.currency.rate || 1) * 100).replace('AUD','').replace('.00',''); 
  }
}

//LOAD:CONVERSION - COMPLEMENTARY
let i = 1;
function elementLoaded(el, cb) { if ($(el).length) { cb($(el)); } else { if (i < 15) { setTimeout(function () { elementLoaded(el, cb); i++; }, 500); } } };
elementLoaded('.product-info__complementary-products', function (el) {

  //A/B:CLICK
  //$('.product-info__complementary-products button').attr("onclick", "ga('send', { hitType: 'event', eventCategory: 'Cart', eventAction: 'Banner Clicked', eventLabel: 'Banner Action' })");

  //BUNDLE
  if (Shopify.currency.active != 'AUD' ) {
    const bundle_text = ($('.product-info__complementary-products .justify-between p').text().split("$")[0]);
    const bundle_saved = (Math.round(($('.product-info__complementary-products .justify-between p').text().split("$")[1]) * (Shopify.currency.rate || 1) * 100));
    if ($('.product-info__complementary-products .justify-between p').text().includes('$')) {
      $('.product-info__complementary-products .justify-between p').text(bundle_text);
      $('.product-info__complementary-products .justify-between p').append('<span>'+formatMoney(bundle_saved,window.themeVariables.settings.moneyFormat.replace("amount", "amount_no_decimals"))+'</span>');
    }
  }
  
});

//ACCORDION FOOTER
$('.accordion__item').on('click', function () {
  //$(this).find('.accordion__item-body');
  $(this).toggleClass('active');
});
$('.accordion__item a').on('click', function () {
  //$(this).find('.accordion__item-body');
  $(this).closest('.accordion__item').toggleClass('active');
});

//SHIPPING ON FLOATING BUTTON
//document.getElementById('free-shipping-label-mobile').style.display = 'none';
//document.getElementById('free-shipping-label-desktop').style.display = 'none';
/*if (document.getElementById('cart-drawer') !=null ){
  window.free_shipping_limit = Math.round(parseFloat(document.getElementById('cart-drawer').getAttribute("threshold")) * (Shopify.currency.rate || 1));
}
if (window.free_shipping_limit < themeVariables.settings.productPrice){
  window.free_shipping = true;

}

if (document.getElementById('free-shipping-label-mobile') != null && document.getElementById('free-shipping-label-desktop') !=null){
  if (window.free_shipping == false) {
    document.getElementById('free-shipping-label-mobile').style.display = 'none';
    document.getElementById('free-shipping-label-desktop').style.display = 'none';
  }
}

document.addEventListener('cart:change', function(event) { 
  if (document.getElementById('pricing-data') != null && document.getElementById('free-shipping-label-mobile') != null && document.getElementById('free-shipping-label-desktop') !=null){
    if (window.free_shipping_limit < event.detail.cart.total_price) {
      document.getElementById('free-shipping-label-mobile').style.display = 'inline-block';
      document.getElementById('free-shipping-label-desktop').style.display = 'inline-block';
    } else {
      document.getElementById('free-shipping-label-mobile').style.display = 'none';
      document.getElementById('free-shipping-label-desktop').style.display = 'none';
    }
   if (window.free_shipping_limit < themeVariables.settings.productPrice){
      document.getElementById('free-shipping-label-mobile').style.display = 'inline-block';
      document.getElementById('free-shipping-label-desktop').style.display = 'inline-block';
   }
  }
});*/

//VIEW SERIES
document.addEventListener('change', function(event) {
  if (event.target.form != null && not_scrolled && event.target.offsetParent != null) {     
    let string = event.target.form.getAttribute('id');
    if (string == null) { return }
    let strip_template = string.split('-template');
    let found_id = strip_template[0].split('form-')[1];
    event.target.offsetParent.setAttribute("data-field-id", found_id);
    
    if (event.target.getAttribute('id') != null && event.target.getAttribute('id').includes('swatch') && document.getElementById('model_'+found_id+'') != null) {   
       const selector_id = event.target.getAttribute('id');
       event.target.offsetParent.setAttribute("data-swatch-position", $('[for='+selector_id+']').position().left);
       $('#model_'+found_id+'').scrollLeft(($('[for='+selector_id+']').position().left));
       //console.log('scrolled 1x');
       window.not_scrolled = false;
    }
  }
});

//SWITCH VARIANT
document.addEventListener('variant:change', function(event) { 
  let product_id = event.detail.product.id;
  let variant = event.detail.variant;

   //BUNDLE OFFER
  window.main_id = event.detail.variant.id;


  if (getSelectedValue("sample") === undefined) {
      window.bundle_id = window.main_id; window.set_qty = 0;
  }
            
  function getSelectedValue(id) {
      return $("#" + id).find("dt div.option-box span.value").attr('data-id');
  }
  
  //console.log("Hi");

  const variant_check = variant.id;
  const product_dispatch = JSON.parse(document.getElementById('product-data-'+ product_id +'').text).product_dispatch;
  const product_check = JSON.parse(document.getElementById('product-data-'+ product_id +'').text).variants;
  const filtered_stock = product_check.reduce((a, o) => (o.id == variant_check && a.push(o.id, o.inventory_quantity ), a), []);
  const filtered_policy = product_check.reduce((a, o) => (o.id == variant_check && a.push(o.id, o.inventory_policy), a), []); 
  const filtered_variant_dispatch = product_check.reduce((a, o) => (o.id == variant_check && a.push(o.id, o.variant_dispatch), a), []); 
  
  variant.inventory_policy = filtered_policy[1];
  variant.inventory_quantity = filtered_stock[1];

  if (variant.inventory_quantity > 0) {
  window.main_id_instock = true;
  } else {
    window.main_id_instock = false;
  }
  
  //console.log(window.main_id_instock);

  if (variant.inventory_policy == "continue" && variant.requires_shipping  && variant.inventory_quantity <= 0) { 
      if (filtered_variant_dispatch[1] != null){
        $('#form-warning--'+ product_id +'').show();
        $('#form-warning--'+ product_id +'').find('.dispatch-date-warning').remove();
        
        $('#input-template--'+ product_id +'').attr('name', 'properties[Dispatch Date]');
        $('#input-template--'+ product_id +'').val(filtered_variant_dispatch[1]);
        $('#form-warning--'+ product_id +'').append("<span class='dispatch-date-warning'>"+filtered_variant_dispatch[1]+"</span>");
        window.dispatch_dates_found = filtered_variant_dispatch[1];
        
      } else {
        if (product_dispatch != null) {
          $('#form-warning--'+ product_id +'').show();
          $('#form-warning--'+ product_id +'').find('.dispatch-date-warning').remove();
          
          $('#input-template--'+ product_id +'').attr('name', 'properties[Dispatch Date]');
          $('#input-template--'+ product_id +'').val(product_dispatch);
          $('#form-warning--'+ product_id +'').append("<span class='dispatch-date-warning'>"+product_dispatch+"</span>");
          window.dispatch_dates_found = product_dispatch
        } else {
          $('#input-template--'+ product_id +'').attr('name', 'empty');
          $('#input-template--'+ product_id +'').val("");
          
          $('#form-warning--'+ product_id +'').hide()
          $('#form-warning--'+ product_id +'').find('.dispatch-date-warning').remove();
          window.dispatch_dates_found = null;
        }
      }
  }
  else {
    $('#input-template--'+ product_id +'').attr('name', 'empty');
    $('#input-template--'+ product_id +'').val("");
    
    $('#form-warning--'+ product_id +'').hide()
    $('#form-warning--'+ product_id +'').find('.dispatch-date-warning').remove();
    window.dispatch_dates_found = null;
  }

  //console.log(window.dispatch_dates_found);

});

//AFTER PAY CONV.
document.addEventListener('variant:change', function(event) {  
  let product_price = formatMoney((event.detail.variant.price)/4);
  if (document.getElementById('product-info-afterpay') != null) { 
    let product_id = document.getElementById('product-info-afterpay').getAttribute('data-produc-id'); 
    if (product_id == event.detail.product.id){
      $('#product-info-afterpay .payment').html(product_price.replace(/\AUD/g, ""));
    }
  }
});

//OPT-OUT HIDE
window.Shopify.loadFeatures([{name:"consent-tracking-api",version:"0.1"},],function e(n){if(n)throw n;(function e(){let n=window.Shopify.customerPrivacy;return n.unstable?n.unstable.saleOfDataRegion():"CCPA"===n.getRegulation()})()||document.head.insertAdjacentHTML("beforeend","<style>.footer__block--menu.accordion__item:nth-child(3) ul li:last-child { display: none; }</style>")});


//SAVED PRICE
function setSavedPrice() {
  $("#cart-drawer .saving").remove();
  var sum = 0;
  $('.cart-drawer__line-items .original-price').each(function() {
      sum += Number($(this).attr("data-amount"));
  });
  
  if ((sum - parseFloat(document.getElementById('pricing-data').getAttribute('data-current-total'))) <= 0) {
      $("#cart-drawer .saving").remove();
  } else {
      $("<p class='saving' style='border: 1px solid #1c9bc9; width: fit-content; margin-left: auto; padding: 5px 10px; margin-top: 10px; color: #1C9BC9; background: #F4FAFC; border-radius: 5px; font-size: 14px; font-weight: 500;'>TOTAL SAVINGS: " + formatMoney(sum - parseFloat(document.getElementById('pricing-data').getAttribute('data-current-total'))) + "</p>").insertAfter("#pricing-data");
  }
}

//SAVED: ONLOAD 
setSavedPrice();

//SAVED: ONCHNG
document.addEventListener('cart:change', function(event) { 
  setTimeout(function() { 
    setSavedPrice();
  }, 2000);
});

//Navigation drawer tabs
jQuery(document).on('click', '.navigation-drawer--tabs .tab-headings > a', function(e){
  e.preventDefault();
  var $tabcontent = $(this).closest('.navigation-drawer--tabs').find('.tab-contents > div'+$(this).attr('href'));
  $(this).addClass('active').siblings().removeClass('active');
  $tabcontent.addClass('active').siblings().removeClass('active');
});

//JSJS
$(document).ready(function () {
  // Function to check if URL contains specific keywords
  function shouldPreselect() {
    const urlChecks = ["powerpack", "powerpack-universal", "powerbase", "chargemat-2"]; // Add more keywords here
    return urlChecks.some((keyword) => window.location.href.includes(keyword));
  }

  // Pre-select the first available option if the URL matches a keyword
  if (shouldPreselect()) {
    var firstAvailableOption = $(".dropdown dd ul li div.choose-option").filter(function () {
      return $(this).closest("li").css("display") !== "none";
    }).first();

    if (firstAvailableOption.length > 0) {
      var text = firstAvailableOption.html();
      $(".dropdown dt div.option-box span").html(text); // Set the dropdown header
      window.bundle_id = firstAvailableOption.find(".value").data("id"); // Set the bundle_id
      window.set_qty = window.main_qty;

      // Show the warning if required (this is for the current functionality)
      if (
        window.bundle_id == 4038232178693800 ||
        window.bundle_id == 4038232181970600 ||
        window.bundle_id == 4038232185247400
      ) {
        $("#form-warning--1").show();
      } else {
        $("#form-warning--1").hide();
      }
    }
  }

  // Handle dropdown toggle
  $(".dropdown dt div.option-box").click(function () {
    $(".dropdown dd ul").toggle();
  });

  $("#form-warning--1").hide();

  // Handle option selection
  $(".dropdown dd ul li div.choose-option").click(function () {
    var text = $(this).html();
    $(".dropdown dt div.option-box span").html(text); // Update dropdown header
    $(".dropdown dd ul").hide(); // Close the dropdown
    $("#form-warning--1").hide();

    if (getSelectedValue("sample") == "NONE") {
      window.bundle_id = window.main_id;
      window.set_qty = 0;
      $("#form-warning--1").hide();
    } else {
      window.bundle_id = getSelectedValue("sample");
      window.set_qty = window.main_qty;

      // Show warning for specific bundle IDs
      if (
        window.bundle_id == 4038232178693800 ||
        window.bundle_id == 4038232181970600 ||
        window.bundle_id == 4038232185247400
      ) {
        $("#form-warning--1").show();
      }
    }
  });

  // Function to get the selected value
  function getSelectedValue(id) {
    return $("#" + id)
      .find("dt div.option-box span.value")
      .attr("data-id");
  }

  // Close dropdown when clicking outside
  $(document).bind("click", function (e) {
    var $clicked = $(e.target);
    if (!$clicked.parents().hasClass("dropdown")) $(".dropdown dd ul").hide();
  });
});


//Redirect
function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = `${cname}=${cvalue};${expires};path=/`;
}

function getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function checkCookieToShow() {
    var cookieValueCheck = getCookie("_locationPopupCookie");

    if (cookieValueCheck == "Hide") {
        $("#popup-block").hide();
    } else {
        var firstVisit = "Seen";
        setCookie("_locationPopupCookie", firstVisit, 30);
        $("#popup-block").show();
    }
}

$("#close-redirect, #close-redirect-stay").click(function(event) {
    event.preventDefault();
    var hidePopup = "Hide";
    setCookie("_locationPopupCookie", hidePopup, 30);
    $("#popup-block").hide();
});


$.getJSON("/browsing_context_suggestions.json")
  .done(function(json) {
    var current_origin = window.location.origin;
    var detectedCountry = json.detected_values.country_name;
    var current_path = window.location.pathname;

    // Simplify detectedCountry logic
    if (['Austria', 'Belgium', 'Croatia', 'Cyprus', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta', 'Netherlands', 'Portugal', 'Slovakia', 'Slovenia', 'Spain'].includes(detectedCountry)) {
        detectedCountry = 'EU';
    } else if (!['EU', 'Australia', 'United States', 'United Kingdom', 'Canada', 'New Zealand'].includes(detectedCountry)) {
        detectedCountry = 'International';
    }

    if (current_origin.includes('snapwireless.com.au')) {
        var currentStore = "Australia";
        var currentStoreISO = "AU";
        $("#au-flag").addClass('active');
    } else if (current_origin.includes('snapwireless.ca')) {
        var currentStore = "Canada";
        var currentStoreISO = "CA";
        $("#ca-flag").addClass('active');
    } else if (current_origin.includes('snapwireless.co.nz')) {
        var currentStore = "New Zealand";
        var currentStoreISO = "NZ";
        $("#nz-flag").addClass('active');
    } else if (current_origin.includes('snapwireless.eu')) {
        var currentStore = "EU";
        var currentStoreISO = "EU";
        $("#eu-flag").addClass('active');
    } else if (current_origin.includes('snapwireless.com')) {
        var currentStore = "United States";
        var currentStoreISO = "US";
        $("#us-flag").addClass('active');
    } else if (current_origin.includes('snapwireless.co.uk') && detectedCountry != 'International') {
        var currentStore = "United Kingdom";
        var currentStoreISO = "UK";
        $("#uk-flag").addClass('active');
    } else if (current_origin.includes('snapwireless.co.uk') && detectedCountry == 'International') {
        var currentStore = "International";
        var currentStoreISO = "INT.";
        $("#int-flag").addClass('active');
    } else {
        var hidePopup = "Hide";
        setCookie("_locationPopupCookie", hidePopup, 24);
        $("#popup-block").hide();
    }

    //console.log(detectedCountry);
    //console.log(currentStore);
    //console.log(currentStoreISO);

    //AU
    if (detectedCountry === 'Australia' && detectedCountry != currentStore) {
        $('#destination-country').text(json.detected_values.country.handle);
        $('#destination-country-message').text('Australian');
        $('#current-country').text(currentStoreISO);
        $("#Switch__store").attr("href", "https://snapwireless.com.au/"+current_path);
        checkCookieToShow();
    }

    //US
    if (detectedCountry === 'United States' && detectedCountry != currentStore) {
        $('#destination-country').text(json.detected_values.country.handle);
        $('#destination-country-message').text(json.detected_values.country.handle);
        $('#current-country').text(currentStoreISO);
        $("#Switch__store").attr("href", "https://snapwireless.com"+current_path);
        checkCookieToShow();
    }

    //CA
    if (detectedCountry === 'Canada' && detectedCountry != currentStore) {
        $('#destination-country').text(json.detected_values.country.handle);
        $('#destination-country-message').text('Canadian');
        $('#current-country').text(currentStoreISO);
        $("#Switch__store").attr("href", "https://snapwireless.ca"+current_path);
        checkCookieToShow();
    }

    //UK
    if (detectedCountry === 'United Kingdom' && detectedCountry != currentStore) {
        $('#destination-country').text('UK');
        $('#destination-country-message').text(json.detected_values.country_name);
        $('#current-country').text(currentStoreISO);
        $("#Switch__store").attr("href", "https://snapwireless.co.uk"+current_path);
        checkCookieToShow();
    }

    //NZ
    if (detectedCountry === 'New Zealand' && detectedCountry != currentStore) {
        $('#destination-country').text(json.detected_values.country.handle);
        $('#destination-country-message').text(json.detected_values.country_name);
        $('#current-country').text(currentStoreISO);
        $("#Switch__store").attr("href", "https://snapwireless.co.nz"+current_path);
        checkCookieToShow();
    }

    //EU
    if (detectedCountry === 'EU' && detectedCountry != currentStore) {
        $('#destination-country').text('EU');
        $('#destination-country-message').text('European');
        $('#current-country').text(currentStoreISO);
        $("#Switch__store").attr("href", "https://snapwireless.eu.com"+current_path);
        checkCookieToShow();
    }

    //INT
    if (detectedCountry === 'International' && detectedCountry != currentStore) {
        $('#destination-country').text("INT.");
        $('#destination-country-message').text('International');
        $('#current-country').text(currentStoreISO);
        $("#Switch__store").attr("href", "https://snapwireless.co.uk"+current_path);
        checkCookieToShow();
    }
  })
  .fail(function() {
      console.error('Failed to load country suggestions.');
  });

if(Shopify.designMode) { $("#popup-block").remove(); };
